import { IconBuildingBank } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { Paragraph6ContractResponse } from "../../Paragraph6.types";

function getCommunityColumn(): MRT_ColumnDef<Paragraph6ContractResponse> {
  return {
    header: "Gemeinde/Kommune",
    accessorKey: "community_name",
    size: 240,
    grow: false,
    enableCellHoverReveal: true,
    // No flex wrapper, so the hover-reveal div overflows and draws the ellipsis
    Cell: ({ cell }) => (
      <>
        <IconBuildingBank
          size="1.3em"
          style={{
            flexShrink: 0,
            marginRight: "var(--mantine-spacing-sm)",
            verticalAlign: "text-bottom"
          }}
        />
        {cell.getValue<string>()}
      </>
    ),
    filterVariant: "multi-select"
  };
}

export { getCommunityColumn };
